import React from 'react';
import { Form, Icon, Message, Button } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import queries from '../../../utils/queries'
import { List } from 'semantic-ui-react'
import general from '../../../modulos/general';

import TitDer from '../../../components/funcionales/titder';

// import EstilosHome from '../../css/home.css';

const DetalleNivel1 = ({styles, elemento, handleClickidLista}) => {
  return (
    <tr className='' onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numSolic}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numCoti}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrProveed}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrProducto}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cantidadCoti}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrUnidad}</td>
      {/* <td className='right aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{general.formatNum(elemento.valorUniCoti.toString())}</td> */}
      <td className='right aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{new Intl.NumberFormat('de-DE').format(elemento.valorUniCoti)}</td>
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.porcDcto}</td>      
      <td className='center aligned' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.porcIVA}</td>      
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.usuarioCreate}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaCreate.substr(0, 10)}</td>
   </tr>  
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento}
        handleClickidLista={handleClickidLista}
        key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

// const AdminCotizacionProve2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {

class AdminCotizacionProve2 extends React.Component {
  state={idListaP: [], argsDocum: {ruta: 0}, checked: true, permiteUpdate: true, confirmaAct: false,
      open: false, errors: [], procBtn: 0, permiteBtn1: true, permiteBtn2: true 
  }

  handleClickidLista = async (ev, idListaP)=>{
    ev.preventDefault()

    this.setState({idListaP: idListaP})
  }

  handleElimItem = async (ev, descrProductoI, idCoti)=>{
    console.log(descrProductoI, idCoti)
    if(descrProductoI){
      const argsUpd = {
        descrProducto: descrProductoI,
        numCoti: idCoti
      }
      argsUpd.tipoAct = "EliminarItem2"
      await this.props.editCotizacion({variables: argsUpd});

      this.props.allCotizacionProRtes2.refetch()
    }else{
      alert("!! Por favor seleccione el item a eliminar !!")
    }
  }

  render(){
    const {idListaP, permiteUpdate, permiteBtn1, permiteBtn2, confirmaAct, open, errors, procBtn} = this.state;
    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})
    const a3570 = this.props.autorizacUA.findIndex( autorizac => autorizac === "3570" );

    let mensaje1 = "Eliminar item de la cotización... "
    if(idListaP.descrProducto){
      mensaje1 = `Eliminar ${idListaP.descrProducto} de la cotización ${idListaP.numCoti}`
    }
    this.props.allCotizacionProRtes2.refetch()
    let list = [], list2 = []
    if(this.props.allCotizacionProRtes2.allCotizacionRtes){list = this.props.allCotizacionProRtes2.allCotizacionRtes}

    return (
      <div>
        <List selection>
          <TitDer list={list} textBoton1="Cotizaciones de proveedores" btnNuevo={a3570!==-1?"SI":"NO"} styles={this.props.styles} handleClick={this.props.handleClick} />
          
          <div style={{height: '35em', overflow: 'auto'}}>
            <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
              <thead className=''>
                <tr className=''> 
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Solicitud</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '12%'}}>Cotización</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Proveedor</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '15%'}}>Producto</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Cantidad</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Unidad</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Valor Und</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>% Descuento</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>% IVA</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Creó</th>
                  <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Fecha</th>
                </tr>
              </thead>
              <Lista list={list} handleClickidLista={this.handleClickidLista} idListaP={idListaP}/>
            </table>
            <p></p>
          </div>
        </List>
        {idListaP.descrProducto &&
          <div className="column" style={{width: '100%', paddingTop: '0.3em'}}>
            <Button id="eliminar" name="eliminar" style={this.props.styles.confirmar} onClick={(ev)=>this.handleElimItem(ev, idListaP.descrProducto, idListaP.numCoti)} fluid>
              {mensaje1}
            </Button>
          </div>
        }

      </div>
    )
  }
};

export default compose(
  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionProRtes2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Proveedor', estadoCoti: 'Creada', tipo: 'Cotización'}},
    {"$unwind": "$itemsCoti"},
    {$project: {_id: {$concat: ['$numCoti', '$itemsCoti.descrProducto']}, fechaCreate: 1, numCoti: 1, 
    usuarioCreate: 1, descrProveed: 1, numSolic: 1, tipo: 1, tipoCoti: 1, estadoCoti: 1,
      cantidadCoti: '$itemsCoti.cantidadCoti', descrProducto: '$itemsCoti.descrProducto', descrUnidad: '$itemsCoti.descrUnidad', 
      valorUniCoti: '$itemsCoti.valorUniCoti', porcIVA: '$itemsCoti.porcIVA', porcDcto: '$itemsCoti.porcDcto'}},   
      {$match: {cantidadCoti: {$gt: 0}}}, 
      {$sort: {numSolic: 1, descrProveed: 1}}
    ]`}}}}),

   
  graphql(queries.mutation.editCotizacion, {name:'editCotizacion'}),

)
(AdminCotizacionProve2)
